import jwtDecode from 'jwt-decode';
import { ROLE_TYPES } from '../constants/roleTypes';

export const impersonateUser = (targetId) => {
    if (!targetId) return;

    localStorage.setItem('target_user_id', targetId);

    window.location.reload();
};

export const stopImpersonating = () => {
    localStorage.removeItem('target_user_id');

    window.location.reload();
};

export const isImpersonating = () => {
    return !!localStorage.getItem('target_user_id');
};

export const isAdminUser = () => {
    const token = localStorage.getItem('token');
    if (!token) return false;

    try {
        const decoded = jwtDecode(token);
        return decoded?.roles?.includes(ROLE_TYPES.ADMIN);
    } catch (error) {
        return false;
    }
};
